module.exports = function () {
    $(document).ready(function () {

        toggleDescription();

        var helper = require('./helper');

        function toggleDescription(){
            $('.guardian-descriptions-heading').on('click', function(){
                var $description = $('.guardian-description-desc'),
                    $arrowUp = $('#guardian-description-arrow-up'),
                    $arrowDown = $('#guardian-description-arrow-down');

                $description.slideToggle();
                $arrowUp.toggle();
                $arrowDown.toggle();
            })
        }

    });
}();